import { configureStore, Middleware } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import { isAuth, user, admin, claims, figures } from './slices'

export const store = configureStore({
    reducer: {
        isAuth,
        user,
        admin,
        claims,
        figures,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(logger as Middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store
